module.exports = __webpack_public_path__ + "img/brandgigwi.cb3f1963.png";